const isFn = x => typeof x === "function";

const plural = (words, count) => {
  words = words.split("|").map(x => x.trim());
  return count > 1 ? words[2].replace("{n}", count) : words[count];
};

// Given a Vuelidate validations object, find the validator keys
export function extractValidatorKeys(validations, validators = []) {
  const keys = Object.keys(validations);
  validators.push(...keys.filter(x => isFn(validations[x])));
  keys
    .filter(x => !isFn(validations[x]))
    .forEach(x => extractValidatorKeys(validations[x], validators));
  return validators;
}

export const getValMessage = messages => validations => {
  let keys = extractValidatorKeys(validations);
  // check to make sure all validators have corresponding error messages
  const missing = keys.filter(x => !(x in messages));
  if (missing.length) {
    console.warn(
      `Validators missing validation messages: ${missing.join(", ")}`
    );
    keys = keys.filter(x => missing.indexOf(x) < 0);
  }
  const keyLen = keys.length;

  // Vue component method
  // Given a vuelidate field object, maybe return an error messsage
  return function(field) {
    if (!field.$dirty) return null;
    let key;
    for (let i = 0; i < keyLen; i++) {
      key = keys[i];
      if (field[key] === false) return messages[key](field.$params[key]);
    }
    return null;
  };
};

export const valMessages = {
  required: () => "This field is required",
  shortRequired: () => "Required",
  notValid: () => "Not valid",
  email: () => "E-mail must be valid",
  phone: () => "Phone must contain 10 digits",
  numeric: () => "Must be a number",
  decimal: () => "Must be a number",
  integer: () => "Must be a whole number",
  positive: () => "Must be larger than 0",
  currency: () => "Enter valid currency format",
  largerThenOne: () => "Must be larger than 1",
  notNegative: () => "Cannot be negative",
  odometer: () => "Must be 4 digits",
  zipCode: () => "Zip code must contain 5 digits",
  noServiceAvailable: () => "No service available in this area",
  serviceAvailable: () => "Zip code already exist in zip code list",
  couponCode: () => "Coupon Code is not valid",
  onlyLettersAndNumbers: () => "Can contain only letters and numbers",
  password: () => "At least 8 characters",
  sameAsPassword: () => "The passwords must match.",
  sameAsEmail: () => "The new email must match.",
  diferentFromOldPassword: () => "New password must differ from current.",
  diferentFromResidentialClientName: () => "Location name must differ from current residential client name.",
  diferentFromOldEmail: () => "New mail must differ from the old one.",
  endDate: () => "Must be after Start Date",
  toDate: () => "Cannot be before From Date",
  startTime: () => "Must be same or before end time",
  endTime: () => "Must be same or after start time",
  beforeBreakStart: () => "Must be same or before break start",
  afterBreakEnd: () => "Must be same or after break end",
  afterShiftStart: () => "Must be same or after shift start time",
  beforeShiftEnd: () => "Must be same or before shift end time",
  afterBreakStart: () => "Must be same or after break start time",
  beforeBreakEnd: () => "Must be same or before break end time",
  breakOverlap: () => "Break times cannot overlap",
  pausedToDate: () => "Must be after Paused From Date",
  agree: () => "You must agree to continue!",
  microdeposit: () => "Must be 2 digits",
  url: () => "Must be valid URL (https://www.example.com/)",
  noCommas: () => "Cannot contain commas",
  noSpecialCharacters: () => "Cannot contain special characters",
  noAmpersandCharacters: () => "Cannot contain '&' character",
  noMultipleSpaces: () => "Cannot contain multiple blank spaces",
  dateFormat: () => "Must be in MM-DD-YYYY format",
  cardNumberRequired: () => "Card number is required",
  expiryMonthRequired: () => "Expiry month is required",
  expiryYearRequired: () => "Expiry year is required",
  cvvRequired: () => "CVV is required",
  cvv: () => "CVV must be 3 or 4 digits",
  cardExpiry: () => "Card expired",
  gaTrackingIdFormat: () => "Incorrect id format",
  colorTooLight: () => "Selected color is too light",
  toPriceValue: () => "Cannot be less than the From Price",
  txtMinLen: params => {
    const min = plural(
      "no characters | one character | {n} characters",
      params.min
    );
    return `Must be at least ${min}`;
  },
  txtMaxLen: params => {
    const max = plural(
      "no characters | one character | {n} characters",
      params.max
    );
    return `Must be less or equal ${max}`;
  },
  arrayMinLen: params => {
    const min = plural("no item | one item | {n} items", params.min);
    return `Must be at least ${min}`;
  },
  serviceDays: params => {
    return `${params.value} service days must be selected`;
  }
};
